import { followUpsSagas } from './FollowUps';

export default [...followUpsSagas];
